export const singleNote = {
  notes: [],
  patient: { firstname: 'Patient', lastName: 'P.' },
};

export const multipleNote = {
  patient: {
    firstName: 'Anna',
    lastName: 'Moris',
    userId: 547,
    gender: 1,
    birthDate: '1990-01-30',
  },
  notes: [
    {
      id: 2251,
      headline: '',
      content: '',
      status: 'draft',
      source: null,
      migratedAt: null,
      visitId: null,
      createdAt: '2022-09-20T06:43:02.554Z',
      updatedAt: '2022-09-20T06:43:02.554Z',
      externalProviderId: null,
      createdBy: 248,
      updatedBy: 248,
      patientId: 305,
      providerId: 41,
      actionItemId: 2641,
      provider: {
        id: 41,
        providers_users: [
          {
            id: 41,
            user: {
              email: 'ann+16@tidepoollabs.com',
              user_detail: {
                firstName: 'Alice',
                lastName: 'in Chains',
              },
            },
          },
        ],
      },
      external_provider: null,
    },
  ],
};

export const createProgressNote = {
  provider: {
    id: 41,
    userId: 248,
    providerId: 41,
    roleId: 11,
    createdAt: '2020-07-06T09:12:48.259Z',
    updatedAt: '2022-09-05T17:37:37.643Z',
    createdBy: null,
    updatedBy: 1,
    user: {
      email: 'ann+16@tidepoollabs.com',
      user_detail: {
        firstName: 'Alice',
        lastName: 'in Chains',
      },
    },
  },
  id: 2250,
  status: 'draft',
  providerId: 41,
  content: '',
  headline: '',
  patientId: 305,
  actionItemId: 2640,
  createdBy: 248,
  updatedBy: 248,
  updatedAt: '2022-09-20T06:26:39.294Z',
  createdAt: '2022-09-20T06:26:39.294Z',
  migratedAt: null,
  visitId: null,
  source: null,
  externalProviderId: null,
};
